"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("../Services/service.service");
var rxjs_1 = require("rxjs");
var conversationService_1 = require("../Services/conversationService");
var material_1 = require("@angular/material");
var token_expired_dialog_component_1 = require("../Dialogs/token-expired-dialog/token-expired-dialog.component");
var delete_account_dialog_component_1 = require("../Dialogs/delete-account-dialog/delete-account-dialog.component");
var AppNavComponent = /** @class */ (function () {
    function AppNavComponent(mainService, conversationService, dialog) {
        this.mainService = mainService;
        this.conversationService = conversationService;
        this.dialog = dialog;
        this.onLogout = new core_1.EventEmitter();
        this.enableSubscription = false;
        this.newMessageCount = 0;
        this.enableSubscription = mainService.enableSubscription;
    }
    AppNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkMessageSubscription = rxjs_1.timer(1000, 5000).subscribe(function () {
            _this.conversationService.getUnreadedMessageCount().then(function (unreadedMessages) {
                if (_this.newMessageCount != unreadedMessages) {
                    _this.newMessageCount = 0;
                    setTimeout(function () {
                        _this.newMessageCount = unreadedMessages;
                    }, 50);
                }
            });
        });
        this.tokenExpirationSubscription = rxjs_1.timer(0, 1000).subscribe(function () {
            if (_this.mainService.userService.isTokenExist() && _this.mainService.userService.isTokenExpired()) {
                _this.tokenExpirationSubscription.unsubscribe();
                var dialogRef = _this.dialog.open(token_expired_dialog_component_1.TokenExpiredDialogComponent, {
                    autoFocus: true,
                    hasBackdrop: true,
                    disableClose: true,
                    data: {},
                });
                dialogRef.afterClosed().subscribe(function () {
                    _this.logout();
                });
            }
        });
    };
    AppNavComponent.prototype.ngOnDestroy = function () {
        this.checkMessageSubscription.unsubscribe();
        this.tokenExpirationSubscription.unsubscribe();
    };
    AppNavComponent.prototype.logout = function () {
        this.mainService.userService.logout();
        this.mainService.showThxLogoutDialog();
        this.onLogout.emit(null);
    };
    Object.defineProperty(AppNavComponent.prototype, "isPremium", {
        get: function () {
            return this.mainService.userService.isPremium();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppNavComponent.prototype, "ShowSpecialBadge", {
        get: function () {
            return this.isPremium || this.isDemo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppNavComponent.prototype, "showUpgradeToPremiumLine", {
        get: function () {
            if (!this.mainService.userService.isAuthenticated()) {
                return true;
            }
            return !(this.mainService.userService.isPremium() || this.mainService.userService.isAdmin() || this.mainService.userService.isDemo());
        },
        enumerable: true,
        configurable: true
    });
    AppNavComponent.prototype.showAllNonDemoAds = function () {
        this.mainService.advService.searchDataStandard.currentSearchRule.nonDemoOnly = true;
        this.mainService.advService.searchDataStandard.currentSearchRule.casualDating = null;
        this.mainService.advService.searchDataStandard.currentSearchRule.pageNumber = 0;
        this.mainService.advService.searchAction(true, "search-results");
    };
    Object.defineProperty(AppNavComponent.prototype, "isDemo", {
        get: function () {
            return this.mainService.userService.isDemo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppNavComponent.prototype, "isAdminOrDemo", {
        get: function () {
            return this.mainService.userService.isDemo() || this.mainService.userService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    AppNavComponent.prototype.showDeleteAccountModal = function () {
        var dialogRef = this.dialog.open(delete_account_dialog_component_1.DeleteAccountDialog, {
            autoFocus: true,
            hasBackdrop: true,
            disableClose: true,
            data: {},
        });
    };
    return AppNavComponent;
}());
exports.AppNavComponent = AppNavComponent;
